import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible.tsx";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { ShortcutBindingsEditor } from "./ShortcutBindingsEditor.tsx";

/**
 * The Settings → General section where shortcuts are rebound. Collapsed by
 * default: the table is long, and most visits to this panel are for the rows
 * above it.
 */
export const KeyboardShortcutsSettings = () => {
  const [open, setOpen] = useState(false);

  return (
    <Collapsible open={open} onOpenChange={setOpen} className="mt-8">
      <CollapsibleTrigger
        className="flex w-full cursor-pointer items-center justify-between py-4 text-left border-b border-border"
        data-statsig-name="settings-customize-shortcuts"
      >
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium">Customize shortcuts</div>
          <div className="text-sm text-muted-foreground mt-0.5">
            Rebind any shortcut to the keys you are used to.
          </div>
        </div>
        <ChevronDown
          className={`size-4 shrink-0 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`}
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-4">
        <ShortcutBindingsEditor />
      </CollapsibleContent>
    </Collapsible>
  );
};
